<style scoped>
.receipt {
  background-color: #F0EEE7;
}
.receipt div {
  margin-bottom: 0;
}
h1, p {
  margin: 1rem 0;
}
.receipt .wrapper {
  background-color: #fff;
  margin: 1.5rem .75rem;
  padding: 0;
  filter: drop-shadow(0 .25rem 2px rgba(0, 0, 0, .25));
}
.receipt .wrapper > div {
  padding: .5rem 1.5rem;
}
.receipt .wrapper:before {
  content: '';
  display: block;
  position: relative;
  top: -.375rem;
  width: 100%;
  height: .5rem;
  background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 8" fill="none" ><path fill="white" d="M0 0L6 4L12 0L18 4L24 0V8L24 8L0 8V0Z" /></svg>');
  background-repeat: repeat;
}
.receipt .wrapper:after {
  content: '';
  display: block;
  position: relative;
  top: .375rem;
  width: 100%;
  height: .5rem;
  background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 8"><path fill="white" d="M0 8L6 4L12 8L18 4L24 8V0L24 0L0 0V0Z" /></svg>');
  background-repeat: repeat;
}
.image.circle {
  margin: auto;
}
.info {
  margin: .5rem;
}
hr.thick {
  margin: .5rem 0;
  background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 4 6"><path stroke="currentColor" stroke-width="2" fill="none" d="M 1 0 V 1 6" /></svg>');
  background-repeat: repeat;
  background-color: #fff;
  width: 100%;
  height: 6px;
}
hr.thin {
  margin: .5rem 0;
  border-top: 2px dotted #000;
}
.receipt .item-list {
  margin: 1rem 0;
}
.total div {
  margin: .5rem 0;
}
</style>

<template>
  <div class="receipt">
    <div class="sub-page-nav has-text-centered">
      <back-arrow></back-arrow>
    </div>
    <div class="wrapper">
      <div>
      <div class="content">
        <div>
          <figure class="image circle is-128x128">
            <cachalog-img class="is-rounded" :type="'background'" :caption="cImage.caption"
              :full-path="cImage.full_path"
              :source="cImage.source"></cachalog-img>
          </figure>
        </div>
        <div class="has-text-centered">
          <h1 class="is-cs-0 has-text-weight-bold">{{ receipt.title }}</h1>
          <p class="is-cs-4 has-text-weight-bold">
            <router-link
              class="is-c-normal-text"
              :to="{name: 'page', params: {pageId: receipt.page_id}}"
            >{{ pageUrl }}</router-link>
          </p>
          <p class="is-cs-5">{{ thanks }}</p>
        </div>
        <hr class="thick">
        <div class="info level is-mobile is-cs-5">
          <time>{{ created }}</time>
          <div>
            <span>担当</span>
            <span>{{ person.nickname }}</span>
          </div>
        </div>
        <hr class="thick">
        <div class="total">
          <div class="level is-mobile is-cs-5">
            <span>お買い上げ点数</span>
            <span><em class="is-cs-1">{{ totalQuantity }}</em> 点</span>
          </div>
          <div class="level is-mobile is-cs-5">
            <span>合計</span>
            <span><em class="is-cs-1">{{ totalAmount }}</em> 円</span>
          </div>
        </div>
        <hr class="thin">
      </div>
      <div class="item-list">
        <receipt-item-list v-for="(item, index) in receipt.items"
          v-if="item.quantity > 0" :item="item" :key="index"></receipt-item-list>
      </div>
      <hr class="thick">
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { mixin, datestr } from '../common.js'
import receiptItemList from '../view/receipt-item-list.vue'
import backArrow from '../design/back-arrow.vue'
export default {
  mixins: [mixin],
  components: {
    'receipt-item-list': receiptItemList,
    'back-arrow': backArrow
  },
  props: ['receiptId'],
  computed: {
    ...Vuex.mapState([
      'cachalogUrl',
      'receipts'
    ]),
    receipt () {
      return this.receipts[this.receiptId] || {items: []}
    },
    cImage () {
      return this.receipt.images && this.receipt.images[1] ? this.receipt.images[1] : {}
    },
    pageUrl () {
      return this.cachalogUrl + this.receipt.page_id
    },
    created () {
      if (this.receipt.created) {
        return datestr(this.receipt.created.toDate(), 'Y/m/d H:i')
      } else {
        return ''
      }
    },
    person () {
      return this.receipt.user || {}
    },
    pageTitle () {
      return this.receipt.title || ''
    },
    thanks () {
      return 'お買い上げありがとうございます！'
    },
    totalQuantity () {
      return this.receipt.items.reduce((a, b) => {
        return a + b.quantity
      }, 0).toLocaleString()
    },
    totalAmount () {
      return this.receipt.items.reduce((a, b) => {
        return a + b.price.value * b.quantity
      }, 0).toLocaleString()
    }
  },
  created () {
    if (!this.receipts[this.receiptId]) {
      this.$store.dispatch('fetchReceipt', this.receiptId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view-model/receipt.vue